import {
  DatePicker,
  Form,
  Input,
  InputNumber,
  message,
  Select,
  Slider,
  Switch,
} from "antd";
import ContentLayout from "../components/layout/ContentLayout";
import { Button as AntButton } from "antd"; // Renaming Ant Design's Button
import Button from "../components/Button"; // Renaming your custom Button
import { useState } from "react";
import TagsInputItem from "../components/TagsInputItem";
import { useQuery } from "@tanstack/react-query";
import {
  createMagiccode,
  getRewards,
  getSchemas,
} from "../actions/acc_actions";
import { useNavigate } from "react-router-dom";

export default function MagiccodeForm({ accUrn, businessUrn, businessSlug }) {
  const navigate = useNavigate();

  const { data: rewardsData } = useQuery({
    queryKey: ["rewards", businessUrn],
    queryFn: () => getRewards(businessUrn),
    enabled: businessUrn ? true : false,
  });

  const { data: schemasData } = useQuery({
    queryKey: ["schemas", businessUrn],
    queryFn: () => getSchemas(businessUrn),
    enabled: businessUrn ? true : false,
  });

  const [isLoading, setIsLoading] = useState(false);
  const [selected, setSelected] = useState("voucher"); // Default selected state
  const [tags, setTags] = useState([]);

  const handleTagsChange = (newTags) => {
    setTags(newTags);
  };

  const handleSubmit = (values) => {
    const formData = {
      accountUrn: accUrn,
      effects: [
        {
          type: selected?.toUpperCase(),
          businessSlug: businessSlug,
          schemeSlug: values.schemeSlug,
          rewardTypeSlug: values.rewardTypeSlug,
          quantity: values.quantity,
          summary: values.summary,
          multiUse: values.multiUse,
          validFrom: values.validFrom?.format("YYYY-MM-DD"),
          validUntil: values.validUntil?.format("YYYY-MM-DD"),
          lifetimeMode: "fixed",
        },
      ],
      message: values.message,
      numberOfSecrets: values.numberOfSecrets,
      claimableFrom: values.claimableFrom?.format("YYYY-MM-DD"),
      claimableUntil: values.claimableUntil?.format("YYYY-MM-DD"),
      maxClaimsPerUser: values.maxClaimsPerUser,
      maxClaimsPerSecret: values.maxClaimsPerSecret,
      maxClaimsPerCode: values.maxClaimsPerCode,
      name: values.name,
      notes: values.notes,
      tags,
    };

    setIsLoading(true);
    createMagiccode(accUrn, formData)
      .then(() => {
        navigate(-1);
        message.success("magic code created successfully");
      })
      .catch(() => {
        message.error("Something Went Wrong!!");
      });
    setIsLoading(false);
  };

  return (
    <ContentLayout
      header={
        <>
          <h1>
            Build a new <span>code batch</span>
          </h1>
        </>
      }
    >
      <Form
        onFinish={handleSubmit}
        layout="vertical"
        className="rewards-form magiccode-form"
      >
        <div className="rewards-form-section">
          <h4>Type</h4>
          <div className="rewards-inputs">
            <Form.Item>
              <div className="form-row radio-btns">
                <Button
                  variant={selected === "voucher" ? "primary" : "secondary"}
                  onClick={() => setSelected("voucher")}
                >
                  Voucher
                </Button>
                <Button
                  variant={selected === "stamp_card" ? "primary" : "secondary"}
                  onClick={() => setSelected("stamp_card")}
                >
                  Stamp Card
                </Button>
              </div>
            </Form.Item>
          </div>
        </div>
        <div className="rewards-form-section">
          <h4>Details</h4>
          <div className="rewards-inputs">
            <Form.Item name="quantity" label="Quantity">
              <Slider
                defaultValue={31}
                min={1}
                max={50}
                step={1}
                tooltip={{ open: true }}
              />
            </Form.Item>
            <Form.Item
              name="summary"
              label="Summary"
              rules={[{ required: true }]}
            >
              <Input />
            </Form.Item>

            <Form.Item
              name="schemeSlug"
              label="Which Scheme is this campaign for?"
              rules={[{ required: true }]}
            >
              <Select
                placeholder="Select Schema"
                options={schemasData?.data?.body.map((item) => ({
                  label: item.name, // Display name as label
                  value: item.slug, // Store the whole object as value
                }))}
              />
            </Form.Item>

            <Form.Item
              name="rewardTypeSlug"
              label="Which Reward is this campaign for?"
              rules={[{ required: true }]}
            >
              <Select
                placeholder="Select Reward"
                options={rewardsData?.data.map((item) => ({
                  label: item.name, // Display name as label
                  value: item.slug, // Store the whole object as value
                }))}
              />
            </Form.Item>
            <Form.Item
              layout="horizontal"
              label="Multi Use"
              name="multiUse"
              valuePropName="checked" // Maps the 'checked' prop of Switch to form state
              initialValue={true} // Ensures the field is initialized in the form state
            >
              <Switch />
            </Form.Item>

            <div className="form-row">
              <Form.Item
                className="date-picker"
                layout="vertical"
                name="validFrom"
                label="From Date"
                rules={[{ required: true }]}
              >
                <DatePicker format="YYYY-MM-DD" style={{ width: "100%" }} />
              </Form.Item>

              <Form.Item
                className="date-picker"
                layout="vertical"
                name="validUntil"
                label="To Date"
                rules={[{ required: true }]}
              >
                <DatePicker format="YYYY-MM-DD" style={{ width: "100%" }} />
              </Form.Item>
            </div>
            <Form.Item name="town" label="Town" rules={[{ required: true }]}>
              <Input />
            </Form.Item>
          </div>
        </div>
        <div className="rewards-form-section">
          <h4>Additional Info</h4>
          <div className="rewards-inputs">
            <Form.Item
              name="message"
              label="Include Message  *"
              rules={[{ required: true }]}
            >
              <Input.TextArea style={{ resize: "none" }} rows={8} />
            </Form.Item>
            <Form.Item name="numberOfSecrets" label="Select Number Of Secrets">
              <Slider min={1} max={50} step={1} tooltip={{ open: true }} />
            </Form.Item>
            <div className="form-row">
              <Form.Item
                className="date-picker"
                layout="vertical"
                name="claimableFrom"
                label="Claimable From"
                rules={[{ required: true }]}
              >
                <DatePicker format="YYYY-MM-DD" style={{ width: "100%" }} />
              </Form.Item>

              <Form.Item
                className="date-picker"
                layout="vertical"
                name="claimableUntil"
                label="Claimable Until"
                rules={[{ required: true }]}
              >
                <DatePicker format="YYYY-MM-DD" style={{ width: "100%" }} />
              </Form.Item>
            </div>
            <Form.Item
              rules={[{ required: true }]}
              label="Max Claims Per Use"
              name="maxClaimsPerUser"
            >
              <InputNumber min={1} max={100} />
            </Form.Item>
            <Form.Item
              rules={[{ required: true }]}
              label="Max Claims Per Secret"
              name="maxClaimsPerSecret"
            >
              <InputNumber rules={[{ required: true }]} min={1} max={100} />
            </Form.Item>
            <Form.Item label="Max Claims Per Code" name="maxClaimsPerCode">
              <InputNumber min={1} max={100} />
            </Form.Item>
            <Form.Item name="name" label="Name">
              <Input />
            </Form.Item>
            <Form.Item name="notes" label="Notes">
              <Input.TextArea style={{ resize: "none" }} rows={8} />
            </Form.Item>
            <Form.Item name="tags" label="Tags">
              <TagsInputItem tags={tags} onTagsChange={handleTagsChange} />
            </Form.Item>
          </div>
        </div>
        <Form.Item className="rewards-form-btn">
          <AntButton
            style={{ border: "1px solid #F11E69" }}
            className="btn primary"
            htmlType="submit"
            type="primary"
            loading={isLoading}
          >
            Submit
          </AntButton>
        </Form.Item>
      </Form>
    </ContentLayout>
  );
}
